module.exports = __webpack_public_path__ + "media/images/WinTAK_CIV-261274ed40901cbc6528d42a88f65705.jpg";